import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '../layouts/DefaultLayout.vue'

const routes = [
	{
	  path: '/login',
	  name: 'login',
	  meta: {
	          exemptAuth: true,
	          title: 'login Page'
	        },
	  component: ()=> import('../components/pages/login.vue')
	}, 
	
  /* 首页 */
  {
    path: '/',
    name: 'Home',
    component: Layout,
	redirect: '/home',
  	children: [
  	      {
  	        path: 'home',
  	        component: () => import('../components/pages/home.vue'),
  	        meta: { title: '首页', noCache: true }
  	      }
  	    ]
  },
  
  /* 业务办理（账号/渠道/设备等主数据在 Checkup.WEB 管理） */
  {
    path: '/business',
    name: '业务办理',
    component: Layout,
  	children: [
		  {
		    path: 'photoInfo',
		    component: () => import('../components/pages/business/photoInfo.vue'),
		    name: '拍照信息管理',
		    meta: { title: '拍照信息管理', noCache: false }
		  },
		  {
		    path: 'paysInfo',
		    component: () => import('../components/pages/business/paysInfo.vue'),
		    name: '缴费信息管理',
		    meta: { title: '缴费信息管理', noCache: false }
		  },
		  {
		    path: 'printRecords',
		    component: () => import('../components/pages/business/printRecords.vue'),
		    name: '打印记录',
		    meta: { title: '打印记录', noCache: false }
		  },
		  {
		    path: 'refund',
		    component: () => import('../components/pages/business/refund.vue'),
		    name: '退款记录',
		    meta: { title: '退款记录', noCache: false }
		  },
  	    ]
  },
  
  /* 统计报表 */
  {
    path: '/form',
    name: '统计报表',
    component: Layout,
  	children: [
  	      {
  	        path: 'number',
  	        component: () => import('../components/pages/form/number.vue'),
  	        name: '时段统计',
  	        meta: { title: '时段统计', noCache: false }
  	      },
		  {
		    path: 'day',
		    component: () => import('../components/pages/form/day.vue'),
		    name: '每日统计',
		    meta: { title: '每日统计', noCache: false }
		  },
		  {
		    path: 'month',
		    component: () => import('../components/pages/form/month.vue'),
		    name: '每月统计',
		    meta: { title: '每月统计', noCache: false }
		  },
		  {
		    path: 'detail',
		    component: () => import('../components/pages/form/detail.vue'),
		    name: '设备统计',
		    meta: { title: '设备统计', noCache: false }
		  },
  	    ]
  },
  
  {
    path: '*',
    component: ()=> import('../components/pages/404.vue')
  },
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => !record.meta.exemptAuth) && to.path !== '/login' && !isUserLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});
 
function isUserLoggedIn() {
  return sessionStorage['_login'] == 'true';
}

export default router
